{
    "Accessibility Menu": "Accessibility Menu",
    "Reset settings": "Astellungen zrécksetzen",
    "Close": "Zoumaachen",
    "Content Adjustments": "Inhalt Unpassungen",
    "Adjust Font Size": "Schrëftgréisst unpassen",
    "Highlight Title": "Titel markéieren",
    "Highlight Links": "Links markéieren",
    "Readable Font": "Liesbar Schrëft",
    "Color Adjustments": "Faarfleg Unpassungen",
    "Dark Contrast": "Däischteren Kontrast",
    "Light Contrast": "Hellen Kontrast",
    "High Contrast": "Héijen Kontrast",
    "High Saturation": "Héij Sättigung",
    "Low Saturation": "Niddrég Sättigung",
    "Monochrome": "Monochrom",
    "Tools": "Tools",
    "Reading Guide": "Guide fir ze liesen",
    "Stop Animations": "Animatiounen stoppen",
    "Big Cursor": "Groussen Cursor",
    "Increase Font Size": "Schrëftgréisst erhéijen",
    "Decrease Font Size": "Schrëftgréisst ernidderegen",
    "Letter Spacing": "Zeechenofstand",
    "Line Height": "Linn Héicht",
    "Font Weight": "Schrëftgewiicht",
    "Dyslexia Font": "Schrëft fir Dyslexie",
    "Language": "Sprooch",
    "Open Accessibility Menu": "Accessibility Menu opmaachen"
  }